import {equals, where} from 'ramda';
import {scroller} from 'react-scroll';

import {DISTANCE} from 'constants/wizard/prescriptionType';
import {Validation} from 'libs/validation/validation';
import {rules as prescriptionRules} from 'libs/wizard/prescriptionErrors/prescriptionErrors';

export type ValidationResultType = {
    sph_od: string;
    sph_os: string;
    cyl_od: string;
    cyl_os: string;
    axi_od: string;
    axi_os: string;
    add_od: string;
    add_os: string;
    pd_left: string;
    pd_right: string;
    isMultiPd: string;
    usage: string;
};

/**
 * Returns a boolean value to get knowledge if we need to notify a customer of a specificity usage a `Distance` package.
 * @param {{value: string, name: string}} parameter - Parameter object. Name can be equal, `sph`, `cyl`, `pd` ad etc.
 * @param {string} usageSku - Selected usage's sku.
 * @returns {boolean} Flag, should notify.
 */
export function shouldNotifyDistance(parameter, usageSku) {
    return parameter.name === 'sph' && parameter.value > 0 && usageSku === DISTANCE;
}

/**
 * Scrolls to an item of the wizard's accordion item
 * @param {string} target - name of the wizard's item
 */
export const wizardScroller = target => {
    scroller.scrollTo(target, {
        duration: 700,
        smooth: true,
        offset: -22,
        delay: 300,
    });
};

/**
 * Checks if the prescription empty or not.
 * @param {PrescriptionType} prescription - Prescription object.
 */
export const isEyePrescriptionEmpty = where({
    sph: equals('None'),
    cyl: equals('None'),
    axi: equals('None'),
});

/**
 * Validates prescription values.
 * @param {string} usageSku - Usage sku.
 * @param {PrescriptionType} prescription - Prescription.
 * @returns {Array<boolean, ErrorsType>} - Validation result.
 */
export const validatePrescription = (usageSku, prescription): [boolean, ValidationResultType] => {
    const validator = new Validation(
        {
            sph_od: prescription.od.sph,
            sph_os: prescription.os.sph,
            cyl_od: prescription.od.cyl,
            cyl_os: prescription.os.cyl,
            axi_od: {value: prescription.od.axi},
            axi_os: {value: prescription.os.axi},
            add_od: {value: prescription.od.add},
            add_os: {value: prescription.os.add},
            pd_left: {value: prescription.pd.left},
            pd_right: {value: prescription.pd.right},
            isMultiPd: {value: prescription.isMultiPD},
            usage: usageSku,
        },
        prescriptionRules,
    );

    return [validator.allPass(''), validator.all()];
};
